import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

export default function HowToCopyImageAddress() {
  return (
    <Container className="py-5" style={{ fontFamily: 'Verdana, sans-serif' }}>
      <Row className="mb-4">
        <Col xs={12} className="text-center">
          <h1 style={{ fontWeight: 500, fontSize: '2.5rem' }}>How to Copy an Image Address</h1>
        </Col>
      </Row>

      <Row className="align-items-center mb-5">
        <Col md={4} xs={12} className="mb-4 mb-md-0 text-center">
          <Image
            src="/qryfox-idea.png"
            alt="Right click menu on image"
            fluid
            title="Kiri the Fox has an idea"
            style={{ maxWidth: '300px', border: '0px solid #ccc', borderRadius: '8px' }}
          />
        </Col>

        <Col md={8} xs={12}>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
            Sometimes, you may want to use an image from a website. To do this, you need the image address (also called a URL).
            Here’s how to get it, step by step:
          </p>
          <ol style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
            <li>Go to a website and find the image you like.</li>
            <li>Put your mouse over the image.</li>
            <li>Click the <strong>right mouse button</strong> (or press and hold if you’re on a tablet).</li>
            <li>A menu will appear. Look for something that says <strong>“Copy image address”</strong> or <strong>“Copy image link”</strong>.</li>
            <li>Click that option.</li>
            <li>Now you can paste that link anywhere you want to use the image.</li>
          </ol>
        </Col>
      </Row>

      <Row className="align-items-center mb-5">

        <Col md={8} xs={12}>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
            You can now use that address inside qrysign, or paste it into a form when it asks for an image URL.
            Just make sure the image link ends in something like <code>.jpg</code>, <code>.png</code>, or <code>.gif</code>.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
            If the image doesn't work, try using a different one. Some websites don’t allow sharing images this way.
          </p>
        </Col>

        <Col md={4} xs={12} className="mb-4 mb-md-0 text-center">
          <Image
            src="/qryfox-play.png"
            alt="Paste image URL"
            fluid
            style={{ maxWidth: '300px', border: '0px solid #ccc', borderRadius: '8px' }}
          />
        </Col>
      </Row>

      <Row className="align-items-center">
        <Col md={4} xs={12} className="mb-4 mb-md-0 text-center">
          <Image
            src="/qryfox-dig.png"
            alt="Tool to inspect media URLs"
            fluid
            style={{ maxWidth: '300px', border: '0px solid #ccc', borderRadius: '8px' }}
          />
        </Col>

        <Col md={8} xs={12}>
          <h3>Using Tools to Find Image or Video Links</h3>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
            Some websites make it hard to copy image or video links directly. You can use extra tools to help:
          </p>
          <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
            <li><strong>Inspect Tool:</strong> Right-click and choose "Inspect" to look at the page’s code. You can find the image or video link in the HTML.</li>
            <li><strong>View Page Info:</strong> In some browsers, you can click the lock icon in the address bar and look at "Media" to see image links.</li>
            <li><strong>Open Source Tools:</strong> Try websites like <code>getvideolink.com</code> or <code>imgsrc.me</code> to help extract links.</li>
          </ul>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
            These tools can help you get the real image or video link when it’s not easy to copy.
          </p>
        </Col>
      </Row>
    </Container>
  );
}